import * as React from 'react';
import { FormattedMessage } from 'react-intl';

import { ButtonModel } from '@notino/react-styleguide';

import { hairAnalyserMessages } from '../messages';
import { StyledButton } from '../styled';

interface ActionButtonProps {
  onOpenHairAnalyzer: () => void;
}

export const ActionButton: React.FC<ActionButtonProps> = ({
  onOpenHairAnalyzer,
}) => {
  const handleClick = (e: React.SyntheticEvent<HTMLElement, Event>) => {
    e.stopPropagation();
    onOpenHairAnalyzer();
  };

  return (
    <StyledButton
      onClick={handleClick}
      buttonStyle={ButtonModel.Styles.secondary}
      type="button"
    >
      <FormattedMessage {...hairAnalyserMessages.hairAnalyserRunDiagnostic} />
    </StyledButton>
  );
};
